import React from 'react';

import { Container } from '@/ui';
import { DocumentSection } from '@/features/constructorDocuments';
import { useScrollToTop } from '@/hooks';

export const DocumentPage = () => {
  useScrollToTop([], { behavior: 'auto' });

  return (
    <Container $paddingBottom={48}>
      <DocumentSection />
    </Container>
  );
};
